module.exports = __webpack_public_path__ + "static/media/plan-banner.5b15d386.png";